import { html } from "lit";
import { customElement, state } from "lit/decorators.js";
import { Api, CreateUserRequest } from "../../api.js";
import { BaseElement } from "../../utils/ui-components.js";

@customElement("user-form")
export class UserForm extends BaseElement {
    @state()
    private loading = false;

    @state()
    private error = "";

    private async handleSubmit(e: Event) {
        e.preventDefault();
        this.loading = true;
        this.error = "";

        const form = e.target as HTMLFormElement;
        const data = new FormData(form);

        try {
            const request: CreateUserRequest = {
                name: data.get("name") as string,
                email: data.get("email") as string,
                password: data.get("password") as string,
                role: data.get("role") as "user" | "admin",
            };

            const newUser = await Api.createUser(request);
            form.reset();
            this.dispatchEvent(new CustomEvent("user-created", { detail: newUser }));
        } catch (e) {
            this.error = "Failed to create user";
        } finally {
            this.loading = false;
        }
    }

    render() {
        return html`
            <form @submit=${this.handleSubmit} class="space-y-4 bg-white p-6 rounded-lg shadow">
                <h2 class="text-xl font-semibold mb-4">Create New User</h2>

                ${this.error ? html`<div class="text-red-600 text-sm">${this.error}</div>` : null}

                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Name</label>
                    <input required name="name" type="text" class="w-full px-3 py-2 border rounded-md" />
                </div>

                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Email</label>
                    <input required name="email" type="email" class="w-full px-3 py-2 border rounded-md" />
                </div>

                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Password</label>
                    <input required name="password" type="password" class="w-full px-3 py-2 border rounded-md" />
                </div>

                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Role</label>
                    <select required name="role" class="w-full px-3 py-2 border rounded-md">
                        <option value="user">User</option>
                        <option value="admin">Admin</option>
                    </select>
                </div>

                <button
                    type="submit"
                    class="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 disabled:opacity-50"
                    ?disabled=${this.loading}
                >
                    ${this.loading ? "Creating..." : "Create User"}
                </button>
            </form>
        `;
    }
}
